import { render, staticRenderFns } from "./surgaltiinBvrtgeliinGerchilgee.vue?vue&type=template&id=07ea7fde&"
import script from "./surgaltiinBvrtgeliinGerchilgee.vue?vue&type=script&lang=js&"
export * from "./surgaltiinBvrtgeliinGerchilgee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports